// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Source+Sans+Pro:wght@400;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.soft-input {
  background-color: #f5f7fa;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  color: #111827;
  box-shadow: none;
  font-family: 'Montserrat', sans-serif;
  height: 35px;
}

.soft-input::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

.soft-input:focus {
  background-color: #f5f7fa;
  border-color: #d1d5db;
  outline: none;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/components/common/FormInput/FormInput.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Source+Sans+Pro:wght@400;600&display=swap');\n\n.soft-input {\n  background-color: #f5f7fa;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 14px;\n  color: #111827;\n  box-shadow: none;\n  font-family: 'Montserrat', sans-serif;\n  height: 35px;\n}\n\n.soft-input::placeholder {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.soft-input:focus {\n  background-color: #f5f7fa;\n  border-color: #d1d5db;\n  outline: none;\n  box-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
